// REM bank status, Defer and Cancel (GIN-18417) — shared constants.

// rem_status_master id for Lost (cancelled applications land here).
export const LOST_STATUS_ID = 7;

// Overall per-bank status codes from the API (bank_status.code).
export const BANK_STATUS = {
  CANCELLED: "cancelled",
  DISBURSED: "disbursed",
  CONTRACT_SIGNED: "contract_signed",
  NOA_RECEIVED: "noa_received",
  NOA_DECLINED: "noa_declined",
  DEFERRED: "deferred",
  IN_PROGRESS: "in_progress",
  PENDING: "pending",
};

// cancel_details.type — Cancel at this bank vs. the whole application.
export const BANK_CANCEL_TYPE = { BANK: "bank", APPLICATION: "application" };

// Stage chip colours on the bank tabs, by the API's stage_status code.
export const STAGE_CHIP_TONE = {
  pending: { dot: "var(--ink-300)", color: "var(--ink-500)" },
  in_progress: { dot: "var(--brand-cyan)", color: "var(--brand-cyan-600)" },
  deferred: { dot: "var(--warning)", color: "var(--warning-text)" },
  cancelled: { dot: "var(--danger)", color: "var(--danger)" },
  completed: { dot: "var(--success)", color: "var(--success)" },
  noa_received: { dot: "var(--success)", color: "var(--success)" },
  noa_declined: { dot: "var(--danger)", color: "var(--danger)" },
  contract_signed: { dot: "var(--success)", color: "var(--success)" },
  contract_declined: { dot: "var(--danger)", color: "var(--danger)" },
};

// Per-bank actions shown as text links under the main button.
export const BANK_ACTION = { DEFER: "defer", RESUME: "resume", CANCEL: "cancel" };

export const BANK_ACTION_LINK_LABEL = {
  [BANK_ACTION.DEFER]: "Defer",
  [BANK_ACTION.RESUME]: "Resume",
  [BANK_ACTION.CANCEL]: "Cancel at this bank",
};

// Confirmation copy for each bank action (BankActionModal).
export const BANK_ACTION_COPY = {
  [BANK_ACTION.DEFER]: {
    title: "Defer at this bank",
    ok: "Defer",
    remark: true,
    remarkLabel: "Remarks",
    placeholder: "Why is this bank deferred?",
    hint: "Deferred date is recorded as today.",
  },
  [BANK_ACTION.CANCEL]: {
    title: "Cancel at this bank",
    ok: "Cancel at this bank",
    remark: true,
    remarkLabel: "Remark",
    placeholder: "Write the reason for cancelling",
    hint: "Cancellation date is recorded as today.",
    warning: (bank) => "This withdraws the application from " + bank + " only. Other banks continue. This cannot be undone.",
    danger: true,
  },
  [BANK_ACTION.RESUME]: {
    title: "Resume at this bank",
    body: "The bank goes back to In Progress.",
    ok: "Resume",
    remark: false,
  },
};

// Remarks for bank actions and Cancel application are capped server-side.
export const REMARK_MAX_LENGTH = 500;
